export default {
  production: '6596babcc144a8a576f0504c',
  development: '673f06d8017ac93cf245491b',
  test: '673f06d8017ac93cf245491b',
};
